import { merge } from 'lodash-es';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { GoogleMap, Marker, withGoogleMap } from 'react-google-maps';
import Config from '../../app.config';
import { getStyles } from '../../utils/common';

const getMapOptions = () => ({
  styles: getStyles(),
  disableDefaultUI: true,
  markerMethod: 'mouseover',
  backgroundColor: 'white',
  fullscreenControl: false,
  zoomControl: true,
});

const markerStyle = {
  fontSize: '1.2rem',
  fontWeight: '800',
  color: '#8DD1D8',
  textAlign: 'center',
};

const markerClickedStyle = {
  fontSize: '1.2rem',
  fontWeight: '800',
  color: '#fff',
  textAlign: 'center',
};

class Map extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      markedLocation: this.props.markedLocation
        ? this.props.markedLocation
        : this.props.locations[0],
      zoom: 10,
      center: {
        lat: this.props.locations
          ? this.props.locations[0].lat
          : this.state.markedLocation.lat,
        lng: this.props.locations
          ? this.props.locations[0].lang
          : this.state.markedLocation.lang,
      },
    };
  }

  render() {
    const GoogleMaps = withGoogleMap(props => {
      const options = merge(getMapOptions(), props.options);
      return (
        <GoogleMap
          ref={map => {
            this.map = map;
          }}
          onZoomChanged={props.onListReactionToZoom}
          onDrag={props.onListReactionToZoom}
          options={options}
          zoom={this.state.zoom}
          center={
            !props.isLocationDetailsClicked && props.selectedLocationDetails
              ? this.state.center
              : {
                  lat: props.selectedLocationDetails.lat,
                  lng: props.selectedLocationDetails.lang,
                }
          }
        >
          {props.locations.map(
            loc =>
              props.isLocationDetailsClicked &&
              props.selectedLocationDetails ? (
                <Marker
                  label={
                    loc.id === props.selectedLocationDetails.id &&
                    (props.isLocationDetailsClicked &&
                      props.selectedLocationDetails)
                      ? {
                          text: String(loc.serialNo),
                          ...markerClickedStyle,
                        }
                      : {
                          text: String(loc.serialNo),
                          ...markerStyle,
                        }
                  }
                  onClick={() => {
                    this.props.handleMarkerClick(loc);
                    this.setState({ markedLocation: loc });
                    this.setState({ zoom: 17 });
                    this.setState({
                      center: {
                        lat: Number(loc.lat),
                        lng: Number(loc.lang),
                      },
                    });
                  }}
                  key={loc.id}
                  animation={window.google.maps.Animation.DROP}
                  icon={
                    loc.id === props.selectedLocationDetails.id
                      ? `${Config.awsCloudFrontUrl}/svg/blue-marker.svg`
                      : `${Config.awsCloudFrontUrl}/svg/white-marker.svg`
                  }
                  position={{
                    lat: Number(loc.lat),
                    lng: Number(loc.lang),
                  }}
                />
              ) : (
                <Marker
                  label={
                    loc.id === this.state.markedLocation.id &&
                    this.props.isMarkerClicked
                      ? {
                          text: String(loc.serialNo),
                          ...markerClickedStyle,
                        }
                      : {
                          text: String(loc.serialNo),
                          ...markerStyle,
                        }
                  }
                  onClick={() => {
                    this.props.handleMarkerClick(loc);
                    this.setState({ markedLocation: loc });
                    this.setState({ zoom: 17 });
                    this.setState({
                      center: {
                        lat: Number(loc.lat),
                        lng: Number(loc.lang),
                      },
                    });
                  }}
                  key={loc.id}
                  animation={window.google.maps.Animation.DROP}
                  icon={
                    loc.id === this.state.markedLocation.id &&
                    this.props.isMarkerClicked
                      ? `${Config.awsCloudFrontUrl}/svg/blue-marker.svg`
                      : `${Config.awsCloudFrontUrl}/svg/white-marker.svg`
                  }
                  position={{
                    lat: Number(loc.lat),
                    lng: Number(loc.lang),
                  }}
                />
              ),
          )}
        </GoogleMap>
      );
    });
    return (
      <div>
        <GoogleMaps
          onListReactionToZoom={() => {
            const bounds = this.map.getBounds();
            const markers = [];
            this.props.locations.map(
              loc =>
                bounds.contains({
                  lat: loc.lat,
                  lng: loc.lang,
                }) && markers.push(loc),
            );
            this.props.handleLocationsInView(markers);
          }}
          locations={this.props.locations}
          selectedLocationDetails={this.props.selectedLocationDetails}
          handleMarkerClick={this.props.handleMarkerClick}
          isLocationDetailsClicked={this.props.isLocationDetailsClicked}
          showInfoWindow
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${
            Config.googleMapsApiKey
          }&v=3.exp&libraries=geometry,drawing,places`}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div className="locations-list__component" />}
          mapElement={<div className="ir locations-list-map__ir" />}
        />
      </div>
    );
  }
}

Map.propTypes = {
  handleMarkerClick: PropTypes.func,
  handleLocationsInView: PropTypes.func,
  locations: PropTypes.array,
  markedLocation: PropTypes.object,
  selectedLocationDetails: PropTypes.object,
  isLocationDetailsClicked: PropTypes.bool,
  isMarkerClicked: PropTypes.bool,
};

export default Map;
